import { render, staticRenderFns } from "./ModifySupportPartnerProfile.vue?vue&type=template&id=ff7222d0&"
import script from "./ModifySupportPartnerProfile.vue?vue&type=script&lang=js&"
export * from "./ModifySupportPartnerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports